import request from "@/utils/axios-v2";

export function getExpenseList(data) {
  return request({
    url: "/fleet/search/expense",
    method: "post",
    data: data,
    headers: {
      "portal-token": true,
    },
  })
}

export function getExpenseFuel(data) {
  return request({
    url: "/fleet/search/fuel/expense",
    method: "post",
    data: data,
    headers: {
      "portal-token": true,
    },
  })
}

export function getExpenseSetting(data) {
  return request({
    url: "/fleet/common/setting",
    method: "get",
    params: data,
    headers: {
      "portal-token": true,
    },
  })
}

export function getExpenseFilter(params) {
  return request({
    url: "/fleet/get/expense/filters",
    method: "get",
    params: params,
    headers: {
      "portal-token": true,
    },
  })
}

export function exportExpenseData(data) {
  return request({
    url: "/fleet/expense/export-by-ids",
    method: "post",
    data: data,
    headers: {
      "portal-token": true,
    },
  })
}


export function putExpenseSetting(data) {
  return request({
    url: "/fleet/common/setting",
    method: "post",
    data: data,
    headers: {
      "portal-token": true,
    },
  })
}
export function getPaidBy(data) {
  return request({
    url: "/fleet/expense/paidBy",
    method: "get",
    data: data,
    headers: {
      "portal-token": true,
    },
  })
}

export function getVehicle(data) {
  return request({
    url: "/fleet/expense/vehicle",
    method: "get",
    data: data,
    headers: {
      "portal-token": true,
    },
  })
}

export function getDriver(data) {
  return request({
    url: "/fleet/expense/driver",
    method: "get",
    data: data,
    headers: {
      "portal-token": true,
    },
  })
}

export function addExpense(data) {
  return request({
    url: "/fleet/expense",
    method: "post",
    data: data,
    headers: {
      "portal-token": true,
    },
  })
}

export function editExpense(data) {
  return request({
    url: "/fleet/edit/expense",
    method: "post",
    data: data,
    headers: {
      "portal-token": true,
    },
  })
}

export function getFuelExpense(data) {
  return request({
    url: "/fleet/search/fuel/expense",
    method: "post",
    data: data,
    headers: {
      "portal-token": true,
    },
  })
}




export function delExpense(data) {
  return request({
    url: "/fleet/expense",
    method: "delete",
    params: data,
    headers: {
      "portal-token": true,
    },
  })
}


export function markAsReviewd(data) {
  return request({
    url: "/fleet/expense/markAsReviewd",
    method: "get",
    params: data,
    headers: {
      "portal-token": true,
    },
  })
}

export function getExpenseInfo(data) {
  return request({
    url: "/fleet/expense/info",
    method: "get",
    params: data,
    headers: {
      "portal-token": true,
    },
  })
}

export function exportExpense(data, params) {
  return request({
    url: "/fleet/search/expense/export",
    method: "post",
    data: data,
    params: params,
    headers: {
      "portal-token": true,
    },
  })
}

export function getFuelChartData(data) {
  return request({
    url: "/fleet/search/expense/fuel/chart",
    method: "post",
    data: data,
    headers: {
      "portal-token": true,
    },
  })
}
export function assignOwner(data) {
  return request({
    url: "/fleet/expense/batch/assign/owner",
    method: "post",
    data: data,
    headers: {
      "portal-token": true,
    },
  })
}
export function exportFuelAll(data) {
  return request({
    url: "/fleet/expense/export/all",
    method: "post",
    data: data,
    headers: {
      "portal-token": true,
    },
  })
}
export function exportFuelSync() {
  return request({
    url: "/fleet/sync/card-info",
    method: "get",
    headers: {
      "portal-token": true,
    },
  })
}

export function getTruckList(params) {
  return request({
    url: "/fleet/fuel/card/truck/list",
    method: "get",
    params: params,
    headers: {
      "portal-token": true,
    },
  })
}
export function updateTruck(params) {
  return request({
    url: "/fleet/expense/assignTruck",
    method: "post",
    data: params,
    headers: {
      "portal-token": true,
    },
  })
}






